import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface FreeDiscountCheckboxProps {
  checked: boolean;
  onToggle: () => void;
}

/** Отметката „Безплатно" до процента на реда — 100% за този ред (решава
 *  `ItemDiscountsModal`). Видът е на отметката в „Закриване" (бакшиш); 32px
 *  висока като chip-а до нея — терминалите са тъчскрийн. */
export const FreeDiscountCheckbox = ({
  checked,
  onToggle,
}: FreeDiscountCheckboxProps) => {
  const { t } = useTranslation();

  return (
    <label className="inline-flex h-8 shrink-0 cursor-pointer items-center gap-1.5 px-1">
      <input
        type="checkbox"
        checked={checked}
        onChange={onToggle}
        className="peer sr-only"
      />
      <span
        aria-hidden
        className={`grid h-4 w-4 shrink-0 place-items-center rounded-[5px] border-[1.5px] text-white transition-colors peer-focus-visible:shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-pos-accent)_30%,transparent)] ${
          checked ? "border-pos-accent bg-pos-accent" : "border-pos-check bg-pos-card"
        }`}
      >
        {checked && <CheckOutlined className="text-[9px]" />}
      </span>
      <span
        className={`whitespace-nowrap text-[12px] font-semibold leading-none ${
          checked ? "text-pos-accent-ink" : "text-pos-soft2"
        }`}
      >
        {t("itemDiscounts.free")}
      </span>
    </label>
  );
};
